import * as React from "react";

import { PageContainer } from "../../../components";
import { DrupalBreedSearchBar } from "../breed/DrupalBreedSearchBar";
import { DrupalClubList } from "./DrupalClubList";
import styled from "styled-components";

const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

export interface IDrupalClubListPageProps {}

export const DrupalClubListPage: React.FunctionComponent<IDrupalClubListPageProps> = () => {
  const [breedId, setbreedId] = React.useState<number>(null);
  return (
    <PageContainer>
      <Container>
        <DrupalBreedSearchBar onSelectionChanged={(b: number) => setbreedId(b)} />
        <DrupalClubList breedId={breedId} />
      </Container>
    </PageContainer>
  );
};
